import { ReactNode, useEffect, useMemo, useState } from "react";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import useBlobStorageFlag from "hooks/useBlobStorageFlag";
import useOriginFlag from "hooks/useOriginFlag";

import { FILTER_TYPE, FILTERS_ORDER_SETTINGS_KEY, INTEGRATIONS_FILTERS } from "../../constants";
import { createIntegrationsFiltersOptionsMap } from "../../helpers";
import { IntegrationView } from "../../types";

type FiltersLayoutProps = {
  children: ReactNode;
  titleId: string;
  integrations: IntegrationView[];
};

const FiltersLayout = ({ children, titleId, integrations }: FiltersLayoutProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const blobStorageEnabled = useBlobStorageFlag();
  const originEnabled = useOriginFlag();

  // workaround. Filters relies on an API request setting the loading state to false on
  // the second render, but we don't have an API request here.
  useEffect(() => {
    setLoading(false);
  }, []);

  const INTEGRATIONS_FILTERS_OPTIONS_MAP = useMemo(
    () => createIntegrationsFiltersOptionsMap(integrations, blobStorageEnabled, originEnabled),
    [integrations, blobStorageEnabled, originEnabled]
  );

  return (
    <Filters
      filters={INTEGRATIONS_FILTERS}
      filtersItemsOptionsMap={INTEGRATIONS_FILTERS_OPTIONS_MAP}
      filtersLoading={loading}
      sortOptions={[]}
      initialSortDirection={null}
      initialSortOption={null}
      pollActiveSections={() => undefined}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersType={FILTER_TYPE}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper titleId={titleId}>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default FiltersLayout;
